import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/system';
import MuiCheckbox from '@mui/material/Checkbox';
import Icon from '@cpg-its/ads.common.icon';
import FormControlLabel from '@cpg-its/ads.form.form-control-label';
import { black, blue, darkBlue, white } from '@cpg-its/ads.constants.colors';
const StyledCheckbox = styled(MuiCheckbox)({
    background: white,
    borderRadius: 0,
    color: black,
    height: 10,
    margin: '0 .75rem',
    padding: 2,
    width: 10,
    '&.Mui-checked': {
        color: blue,
        '&:hover': {
            color: darkBlue,
            backgroundColor: white,
        },
    },
    '&.MuiCheckbox-colorSecondary:hover': {
        backgroundColor: white,
        color: black,
    },
    '&.Mui-checked:hover': {
        backgroundColor: white,
        color: darkBlue,
    },
});
export const CheckboxComponent = ({ checkBoxGroup = false, checked = false, description = '', disabled = false, field = null, form = null, iconColor = '', id = '', label = '', labelColor = null, onChange = () => { }, secondaryLabel = '', secondaryLabelColor = null, testId = undefined, tooltip = {}, value = '', }) => {
    // IE is no longer supported
    // const isIE = window.navigator.userAgent.match(/(MSIE|Trident)/);
    // const iconStyles = isIE ? {
    //   position: 'relative',
    //   right: 6,
    // } : {};
    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        }
        if (!checkBoxGroup && field && form && form.values) {
            if (!Array.isArray(form.values[field.name])) {
                form.setFieldValue(field.name, !value);
            }
        }
    };
    const checkBoxComponent = (_jsx(StyledCheckbox, { checked: checked, checkedIcon: (_jsx(Icon, { color: iconColor, icon: "checkBoxChecked" })), inputProps: testId ? {
            'data-testid': testId,
        } : {}, disabled: disabled, disableRipple: true, icon: (_jsx(Icon, { color: iconColor, icon: "checkBoxOutline" })), id: id, value: value, onChange: handleChange }));
    if (label) {
        return (_jsx(FormControlLabel, { control: checkBoxComponent, description: description, label: label, labelColor: labelColor, secondaryLabel: secondaryLabel, secondaryLabelColor: secondaryLabelColor, tooltip: tooltip }));
    }
    return checkBoxComponent;
};
export default CheckboxComponent;
//# sourceMappingURL=checkbox.js.map